import { Account } from 'types/entity/account';
import ResetPasswordForm from './reset-password-form';
import AlterForm from '../../account/account-atoms/alter-form';

export interface ResetPasswordProps {
  token?: string | string[];
  resetPassword: (password: string) => Promise<Account>;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({ token, resetPassword }) => {
  return (
    <>
      <div className="m-auto grid max-w-screen-sm px-4">
        <ResetPasswordForm token={token} resetPassword={resetPassword} />
      </div>
      <AlterForm page="register" />
    </>
  );
};

export default ResetPassword;
